import Documento from "../Documento";
import DocumentoAcessoGrupo from "./DocumentoAcessoGrupo";
import DocumentoAcessoUsuario from "./DocumentoAcessoUsuario";


export default class DocumentoAcesso {
    documento: Documento | null;
    usuarios: DocumentoAcessoUsuario[];
    grupos: DocumentoAcessoGrupo[];

    constructor(documento: Documento | null = null, usuarios: DocumentoAcessoUsuario[]=[], grupos: DocumentoAcessoGrupo[]=[]) {
        this.documento = documento;
        this.usuarios = usuarios;
        this.grupos = grupos;
    }
}